import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

// Contenido y funciones del servicio
const funciones = [
  "Registro automatizado de anticipos",
  "Generación de facturas de entrega a cuenta",
  "Deducción automática en facturación final",
  "Integración completa con Sage 200",
  "Optimización de la contabilidad empresarial"
];

const ModuloEntregasCuenta = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-aplicacion">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Módulo de Entregas a Cuenta"
        />
        <div className="fondo-aplicacion-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-aplicacion">Módulo de Entregas a Cuenta para Sage 200</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/entregascuenta.jpg`}
          alt="Módulo de Entregas a Cuenta 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Gestiona anticipos y facturas de entrega a cuenta de forma sencilla y automatizada. 
            Este módulo, diseñado para Sage 200, permite registrar y controlar anticipos de manera 
            eficiente, asegurando que cada pago se descuente correctamente en la factura final.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/moduloentregascuenta${num}.jpg`}
                alt={`Módulo de Entregas a Cuenta ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/moduloentregascuenta${num}.jpg`}
              alt={`Módulo de Entregas a Cuenta ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Optimiza tu Contabilidad</h2>
        <p>Automatiza la gestión de anticipos y mantén el control financiero.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default ModuloEntregasCuenta;
